import { render } from "./OdontogramBudgetModal.vue?vue&type=template&id=0a85e14f"
import script from "./OdontogramBudgetModal.vue?vue&type=script&lang=js"
export * from "./OdontogramBudgetModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__